"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCountrDesktop = exports.searchDeviceByUuid = void 0;
/**
 * Search device server-side by uuid
 * @param  {CountrSdk} sdk - Countr sdk obj
 * @param  {string} uuid - uuid Fingerprint returned
 * @returns {Promise<Product[]>}  returns device found or empty array
 */
const searchDeviceByUuid = (countr, uuid) => {
    if ('devices' in countr && !!countr.devices.search) {
        return countr.devices.search({ text: uuid });
    }
    throw Error('Countr instance passed to searchDeviceByUuid is not valid');
};
exports.searchDeviceByUuid = searchDeviceByUuid;
/**
 * Check if Device is Desktop connected
 * @returns {boolean} returns true or false
 */
const isCountrDesktop = () => {
    try {
        const isDesktop = localStorage.getItem('isDesktop');
        return isDesktop !== null && isDesktop === 'true';
    }
    catch (error) {
        throw Error('Cannot access Local Storage to check if isDesktop');
    }
};
exports.isCountrDesktop = isCountrDesktop;
